let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jGERU")).then(() => parcelRequire('7VK3g'));